import React from 'react';
import CompanyChangeRegisterData from './Company';

const ChangeRegisterData: React.FC = () => {
  return <CompanyChangeRegisterData />;
};

export default ChangeRegisterData;
